export default "__VITE_ASSET__f966dddf__"